<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editRegisterBook') }}</h1>
      <div class="form-container">
        <RegisterBookForm :data="relations.instance" @save="save"></RegisterBookForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapState} from 'vuex'
  import RegisterBookForm from "@/components/RegisterBookForm"

  export default {
    components: {
      RegisterBookForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/update', {actionType: 'register_books', payload}).then(() =>
          this.$router.push({ name: 'registerBooks'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'register_books', id: this.$route.params.id})
    },
    computed: {
      ...mapState('Moderator', ['relations']),
      breadcrumbs() {
        return [
          {name: 'registerBooks', path: 'registerBooks'},
          {name: 'editRegisterBook'}
        ]
      }
    }
  }
</script>